var _circle, _circle2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#3D95CA",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.0001 27.8039V57C39.6941 57 39.3701 56.9453 39.1181 56.7996L39.0461 56.7632C35.5901 54.8508 29.56 52.8473 25.654 52.3191L25.132 52.2463C23.404 52.0277 22 50.3885 22 48.64V26.6383C22 24.4709 23.746 22.8317 25.888 23.0138C29.668 23.3235 35.3921 25.2541 38.5961 27.2758L39.0461 27.549C39.3161 27.7129 39.6581 27.8039 40.0001 27.8039Z",
    fill: "#3270FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0001 26.6564V48.6399C58.0001 50.3884 56.5961 52.0276 54.8681 52.2462L54.2741 52.319C50.3501 52.8472 44.302 54.8689 40.846 56.7995C40.612 56.9452 40.324 56.9998 40 56.9998V27.8038C40.342 27.8038 40.684 27.7127 40.954 27.5488L41.26 27.3485C44.464 25.3086 50.2061 23.3597 53.9861 23.0319H54.0941C56.2361 22.8498 58.0001 24.4708 58.0001 26.6564Z",
    fill: "#3270FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3502 34.9801H28.3002C27.5622 34.9801 26.9502 34.3608 26.9502 33.614C26.9502 32.8673 27.5622 32.248 28.3002 32.248H32.3502C33.0882 32.248 33.7002 32.8673 33.7002 33.614C33.7002 34.3608 33.0882 34.9801 32.3502 34.9801Z",
    fill: "#3270FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7002 40.444H28.3002C27.5622 40.444 26.9502 39.8248 26.9502 39.078C26.9502 38.3313 27.5622 37.712 28.3002 37.712H33.7002C34.4382 37.712 35.0502 38.3313 35.0502 39.078C35.0502 39.8248 34.4382 40.444 33.7002 40.444Z",
    fill: "#3270FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.0cf77a86070546d5dffc8c229c103e75.svg";
export { ForwardRef as ReactComponent };